import "core-js/modules/es.number.constructor.js";
import { defineComponent } from "vue";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "playIcon",
  props: {
    playCount: {
      type: Number,
      default: 0
    },
    author: {
      type: String,
      default: ""
    },
    update: {
      type: [String, Number],
      default: 0
    },
    musicCount: {
      type: Number,
      default: 0
    },
    playTime: {
      type: Number,
      default: 0
    }
  },
  setup: function setup() {
    var route = useRoute();
    return {
      route: route
    };
  },
  components: {}
});